import React, { useState } from "react";
import { useNavigate,Navigate } from 'react-router-dom';
import ThemeProvider from 'react-bootstrap/ThemeProvider';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Spinner, Alert } from 'react-bootstrap';
import './login.css';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { loginPending, loginSuccess, loginFail, logout } from "./loginSlice";
import { userLogin } from "../../api/userApi";
import { getUserProfile } from "../backend/dashboard/userAction";


function Copyright(props) {
  return (
    <p className="mt-3 mb-3" variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <a color='inherit' href='#'>
        Royal Arabian Tours
      </a>{' '}
      {new Date().getFullYear()}
      {'.'}
    </p>
  );
}
/* function validateForm() {

  return email.length > 0 && password.length > 0;

} */
//const Login = props => {
const Login = ({ formSwitcher, }) => {
  const dispatch = useDispatch();
  // const history = useHistory();
  const navigate = useNavigate();
  const { isloading, islogIn, error } = useSelector((state) => state.login);
  const accessIsLogIn = localStorage.getItem('accessIsLogIn'); 
   //console.log('isloading- '+isloading+'islogin-'+islogIn+'error-'+error+'accesslogin-'+accessIsLogIn);


  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "password":
        setPassword(value);
        break;

      default:
        break;
    }
  }
  const validateForm = (ev) => {


    return email.length > 0 && password.length > 0;
  }
  const handleOnSubmit = async (event) => {

    event.preventDefault();
    if (!email || !password) {
      return alert("Fill up all th Details!");
    }

    dispatch(loginPending());

    try {
      const islogInCheck = await userLogin({ email, password });
     // console.log(islogInCheck.status);
      if (islogInCheck.status === "error") {
        return dispatch(loginFail(islogInCheck.message));
      }
      
      setTimeout(function() {
        dispatch(loginSuccess());
        navigate('/dashboard');
        //console.log('logged in success ');
    }, 50);
     // console.log('login page '+islogIn);
      //history.push("/dashboard");
     
  
    } catch (error) {
      dispatch(loginFail(error.message));

    }

    /* const data = new FormData(event.currentTarget);
    console.log({
        email: data.get('email'),
        password: data.get('password'),
    }); */
    // alert('A name was submitted: ' + data.get('email'));
    // 👇️ redirect to /contacts
    // history.push('/dashboard');
    //navigate('/dashboard', { replace: true });
    //return <Navigate replace  to="/components/admin/Dashboard" />;
  };

  return (
    <div>
       {islogIn?(
    
      <></>
    ):(
    <div className="login-container-fluid">
      <Row>
        <Col xs lg="7" className="login-bg"><div></div></Col>
        <Col xs lg="5">

          <div className="login-second-col">
            <img
              src='/images/RATourlogo.webp'
              srcSet='/images/RATourlogo.webp'
              alt='Royalarabian Tours'
              loading="lazy"

            />
            <ThemeProvider
              breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
              minBreakpoint="xxs"
            >
              <form className=" mt-5" component="form" noValidate onSubmit={handleOnSubmit}>
                <h4 className="sign-in">Sign In</h4>
                {error && <Alert variant={islogIn === true ? "success" : "danger"}>{error}</Alert>}
                <Form.Floating className="mb-3 mt-5">
                  <Form.Control
                    id="floatingInputCustom"
                    autoFocus
                    type="email"
                    value={email}
                    //onChange={(e) => setEmail(e.target.value)}
                    onChange={handleOnChange}
                    placeholder="name@example.com"
                    name="email"
                  />
                  <label htmlFor="floatingInputCustom">Email address</label>
                </Form.Floating>
                <Form.Floating className="mb-3 ">
                  <Form.Control
                    id="floatingPasswordCustom"
                    type="password"
                    placeholder="Password"
                    name="password"
                    value={password}
                    autoComplete= ""
                    // onChange={(e) => setPassword(e.target.value)}
                    onChange={handleOnChange}
                  />
                  <label htmlFor="floatingPasswordCustom">Password</label>
                </Form.Floating>

                <div className="mb-3">
                  <div className="form-check text-start" >
                    {/* <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                    <label className="form-check-label text-start custom-control-label" htmlFor="flexCheckDefault">
                      Remember me
                    </label> */}
                  </div>

                </div>
                <div className="d-grid">
                  <button type="submit" className="btn btn-primary" disabled={!validateForm()}>
                    Submit
                  </button>
                  {isloading && <Spinner animation="border" variant="primary" />}

                </div>
                <p className="forgot-password text-right">
                  <a href="/forgot-password"> Forgot password?</a>
                </p>
              </form>
              <hr />
              <br />
              <Copyright />
            </ThemeProvider>
          </div>
        </Col>
      </Row>

    </div>
   
    )}
    </div>
  );
}
Login.prototype = {
  formSwitcher: PropTypes.func.isRequired,
}
export default Login;